<template>
  
</template>

<script>

export default {
  name: 'ProjectHero',
  data () {
    return {
      aaa: 'bbb'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/_ProjectHero.vue